import environment from '../environments';

// Check if section is enabled/disbled on navigation
export const isSectionEnabled = (sectionKey: string) => {
  return environment.navigation.some(
    navigationItem => navigationItem.label === sectionKey
  );
};
